import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class StatusQueryData<T = any> {
  private _api = inject(FsApi);


  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `statusqueries/${id}`,
      query,
      {
        key: 'statusQuery',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'statusqueries',
      query,
      {
        key: 'statusQueries',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `statusqueries/${data.id}`,
      data,
      {
        key: 'statusQuery',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `statusqueries/${data.id}`,
      data,
      {
        key: 'statusQuery',
        ...config,
      },
    );
  }

  public query(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      `statusqueries/${data.id}/query`,
      data,
      {
        key: 'statusQuery',
        ...config,
      },
    );
  }


  public debug(queryStatusId: any, data, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      `statusqueries/${queryStatusId}/debug`,
      data,
      {
        key: '',
        ...config,
      },
    );
  }

}
